import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Card } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import CButton from "../../../../components/buttons/Button";

function Items({
  currentItems,
  downloadFile,
  isBusinessList,
  setShowModal,
  setApproveorderId,
  RejectOrder,
  setEdit
}) {
  return (
    <>
      {isBusinessList ? (
        currentItems.map((values) => (
          <>
            <div className="row">
              <div className="col-1"></div>
              <div className="col-10 text-dark mb-4">
                <h6>
                  <b>Registered Domain :</b> {values.portal_url}
                  <FontAwesomeIcon
                    icon={faPencil}
                    className={"ms-2 text-success"}
                    onClick={() => setEdit(values.mpi_id)}
                  />
                </h6>
                <h6>
                  <b>Description :</b>{" "}
                  {values.data_pub_siteinfos[0]
                    ? values.data_pub_siteinfos[0]["description"]
                    : ""}
                </h6>
                <h6>
                  <b>Monthly Earnings :</b> $ 0.00{" "}
                </h6>
              </div>
              <div className="col-1"></div>
            </div>
          </>
        ))
      ) : currentItems.length > 0 ? (
        currentItems.map((items) => (
          <>
            <Card
              className="py-2 border border-0 shadow shadow-md rounded-3 bg-primary-soft mb-5"
              style={{ height: "auto" }}
            >
              <Card.Body>
                <Card.Title
                  className="text-center mb-4 mt-2"
                  style={{ color: "#044389" }}
                ></Card.Title>
                <div className="row">
                  <div className="col-6 text-dark">
                    <h6>
                      <b>Order# :</b> {items.doi_id}
                    </h6>
                    <h6>
                      <b>Date :</b> {items.order_date.split("T")[0]}
                    </h6>
                    <div style={{ flexDirection: "row", display: "flex" }}>
                      <div className="mt-1">
                        <h6>
                          <b>Article :</b>
                        </h6>
                      </div>
                      <CButton
                        btnClasses={
                          "btn btn-sm text-decoration-none text-light ms-1"
                        }
                        btnCustomStyle={{
                          backgroundColor: "#044389",
                        }}
                        innertext={"View File"}
                        functionName={() => downloadFile(items.doi_id)}
                      />
                    </div>
                  </div>
                  <div className="col-6 text-dark">
                    <h6>
                      <b>Advertiser :</b>{" "}
                      {items.data_mkt_reg.firstname +
                        " " +
                        items.data_mkt_reg.lastname}
                    </h6>
                    <h6>
                      <b>Status :</b> {items.master_order_status.name}
                    </h6>
                  </div>
                </div>
                <div className="row text-center mt-3">
                  {items.master_order_status.name === "Processing" ? (
                    <>
                      <div className="col-6">
                        <CButton
                          btnClasses={
                            "btn btn-md text-decoration-underline text-success fw-bold"
                          }
                          innertext={"Approve"}
                          functionName={() => {
                            setApproveorderId(items.doi_id);
                            setShowModal(true);                          
                          }}
                        />
                      </div>
                      <div className="col-6">
                        <CButton
                          btnClasses={
                            "btn btn-md text-decoration-underline text-danger fw-bold"
                          }
                          innertext={"Reject"}
                          functionName={() => RejectOrder(items.doi_id)}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </Card.Body>
            </Card>
          </>
        ))
      ) : (
        <h5 className="text-dark text-center">
          There are no records to display
        </h5>
      )}
    </>
  );
}

function PaginatedItems({
  itemsPerPage,
  items,
  isBusinessList,
  downloadFile,
  setShowModal,
  setApproveorderId,
  RejectOrder,
  setEdit
}) {
  const [itemOffset, setItemOffset] = useState(0);

  const endOffset = itemOffset + itemsPerPage;
  // console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = items.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(items.length / itemsPerPage);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;

    // console.log(
    //   `User requested page number ${event.selected}, which is offset ${newOffset}`
    // );
    setItemOffset(newOffset);
  };

  return (
    <>
      <Items
        currentItems={currentItems}
        isBusinessList={isBusinessList}
        downloadFile={(id) => downloadFile(id)}
        setShowModal={(status) => setShowModal(status)}
        setApproveorderId={(id) => setApproveorderId(id)}
        RejectOrder={(id) => RejectOrder(id)}
        setEdit={(id) => setEdit(id)}
      />
      <ReactPaginate
        nextLabel="next >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={1}
        marginPagesDisplayed={1}
        pageCount={pageCount}
        previousLabel="< previous"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination justify-content-center"
        activeClassName="active"
        renderOnZeroPageCount={null}
      />
    </>
  );
}

const MyPortalMobile = (props) => {
  return (
    <>
      <h4 className="text-dark mb-5 fw-bolder text-center">Dashboard</h4>
      <PaginatedItems
        itemsPerPage={1}
        isBusinessList={true}
        items={
          props.businessList.data !== undefined &&
          props.businessList.data.length > 0
            ? props.businessList.data
            : []
        }
        downloadFile={(id) => props.downloadFile(id)}
        setShowModal={(status) => props.setShowModal(status)}
        setApproveorderId={(id) => props.setApproveorderId(id)}
        RejectOrder={(id) => props.RejectOrder(id)}
        setEdit={(id) => props.setEdit(id)}
      />
      <Link to="/dashboard/add-new-business">
        <CButton
          btnClassesDiv={"text-center mb-5"}
          btnClasses={"btn px-4 fw-bold text-white mt-3"}
          IsOutline={false}
          innertext={"Add new Business"}
          btnCustomStyle={{
            backgroundColor: "#044389",
          }}
        />
      </Link>
      <h4 className="text-dark text-center fw-bold mb-5 mt-3">
        Ongoing Orders
      </h4>
      <PaginatedItems
        itemsPerPage={2}
        items={
          props.ongoingOrderList !== undefined ? props.ongoingOrderList : []
        }
        downloadFile={(id) => props.downloadFile(id)}
        setShowModal={(status) => props.setShowModal(status)}
        setApproveorderId={(id) => props.setApproveorderId(id)}
        RejectOrder={(id) => props.RejectOrder(id)}
        setEdit={(id) => props.setEdit(id)}
      />
    </>
  );
};

export default MyPortalMobile;
